import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getRewardsProducts } from 'services/RewardsService'
import { GetRewardsProductsParams } from 'types/rewards'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'
import { TEN_MINUTES } from 'utils/utils'

interface UseRewardsProductsQueryOptions extends GetRewardsProductsParams {
  enabled?: boolean
}

export const useRewardsProductsQuery = (options?: UseRewardsProductsQueryOptions) => {
  const {
    enabled = true,
    pageSize = API_PAGINATION_LIMIT,
    pageNumber = API_PAGINATION_OFFSET,
    currency,
  } = options || {}

  return useQuery({
    queryKey: reactQueryKeys.rewardsProducts(pageNumber, pageSize, currency),
    queryFn: () => getRewardsProducts({ pageSize, pageNumber, currency }),
    enabled,
    staleTime: TEN_MINUTES,
  })
}
